// import React from 'react';
// import ReactDOM from 'react-dom';
// import GoogleLogin from 'react-google-login';


// const Login=()=>{

// const responseGoogle = (response) => {
//   console.log(response);
// }
// return(

//   <GoogleLogin
//     clientId="1010594964171-v4inrc7aeos5rhvmo3mj5o82us2ua4b9.apps.googleusercontent.com"
//     buttonText="Login"
//     onSuccess={responseGoogle}
//     onFailure={responseGoogle}
//     cookiePolicy={'single_host_origin'}

//   />

// );
// }
// export default Login;
import React, { useState } from 'react';
import './Login.css'
import { Link, useHistory } from "react-router-dom";
import { auth } from "./Fire";
import Logo from '../Category/Languages/assets/logo.png'
function Login() {
    
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    return (
    <div className='login'>
    <Link to='/'>
        <img
            className="login__logo"
            src={Logo}    />
    </Link>

    <div className='login__container'>
        <h1>How To Log-in or Create your account? </h1>
        <ul>
            <li>If You have an Account on Noob Geeks </li>
            <ol>
                <li>Then, Simply write the Email ID and Password</li>
            </ol>
            <li>If you are new to NooB Geeks  </li>
            <ol>
                <li>Then Decide your ID and password</li>
                <li>Click on Create Account , Your account will get created</li>
            </ol>
        </ul>

        <form>
            <h5>E-mail</h5>
            <input type='text' value={email} onChange={e => setEmail(e.target.value)} />

            <h5>Password</h5>
            <input type='password' value={password} onChange={e => setPassword(e.target.value)} />

            <button type='submit' className='login__signInButton'>Sign In</button>
        </form>

       

        <button className='login__registerButton'>Create your NooBGeeks Account</button>
    </div>
</div>
)
}
export default Login